import { render } from "./ServiceBody.vue?vue&type=template&id=c3bc089a&scoped=true"
import script from "./ServiceBody.vue?vue&type=script&lang=js"
export * from "./ServiceBody.vue?vue&type=script&lang=js"

import "./ServiceBody.vue?vue&type=style&index=0&id=c3bc089a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3bc089a"]])

export default __exports__